/**
 * Backups
 * @param {DOMElement} obj
 * @return {void}
 */
function spbcActionBackupsRollback(obj) { // eslint-disable-line no-unused-vars
    if (!confirm('Are you sure want to rollback to this backup?')) {
        return;
    }
    let self = jQuery(obj);
    let data = {
        action: 'spbc_rollback',
        backup_id: self.parent().attr('uid'),
        cols: self.parent().attr('cols_amount'),
    };
    let params = {
        spinner: self.parent().siblings('.tbl-preloader--tiny'),
        callback: function(result, data, params, obj) {
            if (result.success) {
                if (result.color) {
                    obj.css({background: result.background, color: result.color});
                }
                if (result.html) {
                    obj.html(result.html); setTimeout(function() {
                        obj.fadeOut(300);
                    }, 1500);
                }
            }
        },
    };

    spbcSendAJAXRequest(data, params, self.parents('tr'));
}

/**
 * Delete
 * @param {DOMElement} obj
 * @return {void}
 */
function spbcActionBackupsDelete(obj) { // eslint-disable-line no-unused-vars
    if (!confirm('Are you sure want to delete this backup?')) {
        return;
    }
    let self = jQuery(obj);
    let data = {
        action: 'spbc_backup__delete',
        backup_id: self.parent().attr('uid'),
        cols: self.parent().attr('cols_amount'),
    };
    let params = {
        spinner: self.parent().siblings('.tbl-preloader--tiny'),
        callback: function(result, data, params, obj) {
            if (result.success) {
                if (result.color) {
                    obj.css({background: result.background, color: result.color});
                }
                if (result.html) {
                    obj.html(result.html); setTimeout(function() {
                        obj.fadeOut(300);
                    }, 1500);
                }
            }
        },
    };

    spbcSendAJAXRequest(data, params, self.parents('tr'));
}

jQuery(document).ready(function() {
    spbcTblSortListen();

    // Preparing accordion
    jQuery('#spbc_scan_accordion2').accordion({
        header: 'h3',
        heightStyle: 'content',
        collapsible: true,
        active: false,
        beforeActivate: function(event, ui) {
            // jQuery( "#spbc_scan_accordion" ).accordion( "option", "active", 2 );
        },
    });
});
